import React, { Component } from 'react'
import ErrorPage from './ui/errorpages/error_page';
import { Result, Button } from 'antd';
import { withRouter } from 'react-router-dom';

class ErrorWrapper extends Component {

    constructor(props) {
        super(props)


        // if(this.props.children.length>1){
        //     throw new Error("Error Wrapper can only contain single child");
        // }
    }
    
    render() {
        let error=this.props.error||{};
        // console.log("ERRPR IS",error)
        if(error.no_access){
            return <Result
            status="403"
            title="403"
            subTitle={this.props.no_access||(typeof error.error_message==='string'&&error.error_message)||"Sorry, you are not authorized to access this information."}
            extra={!this.props.no_back_action&&<Button onClick={() => {
                try {
                    this.props.history.goBack();
                } catch (e) {

                }
            }} type="link">Go Back</Button>}
          />
        }
        else if((error.not_found)){
            return <Result
            status="404"
            title="404"
            subTitle={this.props.not_found||(typeof error.error_message==='string'&&error.error_message)||"Sorry, the requested data does not exist."}
            extra={!this.props.no_back_action&&<Button onClick={() => {
                try {
                    this.props.history.goBack();
                } catch (e) {

                }
            }} type="link">Go Back</Button>}
        />
        }
        else  if((error.server_error)){
            return <Result
            status="500"
            title="500"
            subTitle={this.props.server_error||(typeof error.error_message==='string'&&error.error_message)||"There was some error in the server"}
            extra={<span>
                {false&&<Button onClick={() => {
                try {
                    this.props.history.goBack();
                } catch (e) {

                }
            }} type="link">Go Back</Button>}
            <Button onClick={() => {
                try {
                    this.props.onReload();
                } catch (e) {

                }
            }} type="link">Try Again</Button>

            </span>}
        />
        }
        // console.log(error)
        else if(error.no_net){
            return   <Result
            status="warning"
            title="There was some problems with your operation."
            extra={
                typeof this.props.onReload==='function'&&
              <Button type="primary" key="console" onClick={()=>{
                  this.props.onReload()
              }}>
                Try again
              </Button>
            }
          />
        }
        else if(error.timeout){
            console.log("Server Error")
            return <ErrorPage
            onReload={this.props.onReload}
             />
            
        }
        else {
            return <React.Fragment>
                    {this.props.children}
            </React.Fragment>
        }

    
    }


    // componentWillReceiveProps(nextProps){
    //     if(nextProps.children.length>1){
    //         throw new Error("Error Wrapper can only contain single child");
    //     }
        
    //     if(nextProps.network_error!==this.props.network_error){
    //       //Perform some operation
    //       this.setState({network_error: nextProps.network_error });
    //     }
    //   }
}

export default  ErrorWrapper=withRouter(ErrorWrapper)
